export interface IPriority {
  priority?: number;
}
